import React from "react"
import { Formik, Form as FormikForm, Field } from "formik"
import { Row, Form } from "react-bootstrap"
import * as Yup from "yup"
import * as ErrorMessage from "../../common/errorMessage"
import * as Regex from "../../common/regex"
import * as Constants from "../.././common/constants"
import * as Alert from "../../services/sweetalertService"

import FormEditUpload from "../shared/formEditUpload"
import FormTextbox from "../shared/formTextbox"
import FormFieldDisableAutoComplete from "../shared/formFieldDisableAutoComplete"
import FormDisabledTextBox from "../shared/FormDisabledTextBox"
import FormRadioButton from "../shared/formRadioButton"
import {
  updateValidFormData,
  updateFormIsValid,
  controlDeclaration,
  editAllInvalidForm,
  updateUiData,
  updateClickedNext,
} from "../../redux/actions"
import { useDispatch, batch } from "react-redux"

//import { useStaticQuery, graphql, navigate } from "gatsby"
//import { useDispatch } from "react-redux"
//import { updateClaimInfo } from "../../actions"

const ReviewClaim = ({ claimData, uiData }) => {
  const dispatch = useDispatch()
  const {
    pageNumber,
    clickedNext,
    witnessFieldIsEmpty,
    hideHeaderFooter,
  } = uiData

  const formRef = React.useRef()

  const policyInfoSchema = Yup.object().shape({
    policyHolderEmail: Yup.string()
      .required(ErrorMessage.policyHolderEmail)
      .email(ErrorMessage.policyHolderEmail),

    policyHolderTel: Yup.string()
      .required(ErrorMessage.policyHolderTel)
      .matches(Regex.mobilepattern, ErrorMessage.policyHolderTel),

    otherInsurance: Yup.string().when("isOtherInsuranceCovering", {
      is: isOtherInsuranceCovering => isOtherInsuranceCovering,
      then: Yup.string().required(ErrorMessage.otherInsurance),
    }),
  })

  return (
    <Row className={pageNumber === 5 ? "" : "hide"}>
      <div
        className={
          "title text-center " +
          (pageNumber === 5 ? "" : "hide") +
          " " +
          (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
        }
      >
        Review and modify the claim information
      </div>
      <div className="marginTop1x borderBottomDottedGrey noPaddingLeftRightSmallScreen mb-4 bigScreenNarrowing width100">
        <div className="col-12 benefitsHeaderSummaryDiv">
          Claimant Information
        </div>
      </div>
      <Row className="col-xs-12 containerBody summaryContainerBody mb-4 blueBG">
        <Formik
          initialValues={Object.assign({}, claimData["claimLiabilityDetail"])}
          enableReinitialize={true}
          validationSchema={policyInfoSchema}
          validateOnMount={true}
          innerRef={formRef}
          onSubmit={(values, actions) => {}}
        >
          {({
            values,
            errors,
            touched,
            dirty,
            handleChange,
            handleBlur,
            handleSubmit,
            meta,
            props,
            isValid,
          }) => (
            <FormikForm
              id="summary"
              onSubmit={handleSubmit}
              className="formContainer offset-xs-0 col-xs-12 col-md-12"
            >
              {" "}
              <Form.Group>
                <Row className="form-group">
                  <div className="col-12 textforinput marginTop10px benefitEditTitle">
                    <p>Please review the claimant information</p>
                  </div>
                </Row>
              </Form.Group>
              {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
              <Field
                textDesc={"Disable Auto Complete"}
                name="disableAutoComplete"
                component={FormFieldDisableAutoComplete}
              />
              <Field
                textDesc={"Policy Number"}
                name="policyNumber"
                component={FormDisabledTextBox}
                toUpperCase={true}
              />
              <Field
                textDesc={"Policy Holder Name"}
                name="policyHolderName"
                component={FormDisabledTextBox}
                toUpperCase={true}
              />
              <Field
                textDesc={"Policyholder's Email"}
                maxLength={100}
                name="policyHolderEmail"
                component={FormTextbox}
                toUpperCase={false}
              />
              <Field
                textDesc={"Policyholder's Telephone Number"}
                maxLength={9}
                name="policyHolderTel"
                component={FormTextbox}
                toUpperCase={false}
              />
              <Field
                textDesc={
                  "Do you have other insurance covering you in respect of this accident?"
                }
                name="isOtherInsuranceCovering"
                component={FormRadioButton}
              />
              {values.isOtherInsuranceCovering && (
                <>
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete2"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Please provide details of other insurance."
                    maxLength={9}
                    name="otherInsurance"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                </>
              )}
              {
                <FormEditUpload
                  editBenefits={true}
                  allProofDocuments={uiData.proofDocuments}
                  claimUploadListModel={uiData.claimUploadListModel}
                />
              }
              <HandleFormValidation
                reviewPageClickedNext={clickedNext[5]}
                formRef={formRef}
                values={values}
                pageNumber={pageNumber}
                dispatch={dispatch}
                formName={Constants.reviewFormName}
              />
              <HandleFinalValidation
                reviewPageClickedNext={clickedNext[5]}
                dispatch={dispatch}
                uiData={uiData}
                formIsValid={uiData.formIsValid}
                witnessFieldIsEmpty={witnessFieldIsEmpty}
              />
            </FormikForm>
          )}
        </Formik>
      </Row>
    </Row>
  )
}

const HandleFormValidation = ({
  reviewPageClickedNext,
  formRef,
  values,
  pageNumber,
  dispatch,
  formName,
}) => {
  React.useEffect(() => {
    if (reviewPageClickedNext) {
      formRef.current.validateForm().then(errors => {
        // console.log(errors)

        batch(() => {
          if (Object.entries(errors).length === 0) {
            // console.log("PASS")
            dispatch(updateValidFormData("claimLiabilityDetail", values))
            dispatch(updateFormIsValid(formName, true))

            // dispatch(pageIncrement())
            // dispatch(updateClickedNext(pageNumber, false))
          } else {
            // console.log("FAIl")
            // Alert.missingInfoAlert()
            formRef.current.submitForm() // Set touched to all fields
            dispatch(updateFormIsValid(formName, false))

            // dispatch(updateClickedNext(pageNumber, false))
          }
        })
      })
    }
  }, [formRef, values, pageNumber, dispatch, reviewPageClickedNext, formName])
  return null
}

const HandleFinalValidation = ({
  reviewPageClickedNext,
  dispatch,
  uiData,
  formIsValid,
  witnessFieldIsEmpty,
}) => {
  React.useEffect(() => {
    if (
      uiData.clickedNext[5] &&
      formIsValid.hasOwnProperty([Constants.reviewFormName]) &&
      formIsValid.hasOwnProperty([Constants.lossDetailsFormName]) &&
      formIsValid.hasOwnProperty([Constants.payoutFormName])
    ) {
      batch(() => {
        let finalValidatePass = true
        let invalidForm = []
        if (!formIsValid[Constants.reviewFormName]) {
          finalValidatePass = false
        }
        if (!formIsValid[Constants.lossDetailsFormName]) {
          invalidForm.push(Constants.lossDetailsFormName)
          finalValidatePass = false
        }
        if (!formIsValid[Constants.payoutFormName]) {
          invalidForm.push(Constants.payoutFormName)
          finalValidatePass = false
        }
        if (!finalValidatePass) {
          dispatch(editAllInvalidForm(invalidForm))
          Alert.pleaseCheckInfoAlert()
          if (witnessFieldIsEmpty) {
            dispatch(updateUiData("witnessFieldIsEmpty", false))
            Alert.pleaseAddWitnessBeforeNext()
          }
        } else {
          dispatch(controlDeclaration())
        }
        dispatch(updateUiData("formIsValid", {}))

        dispatch(updateClickedNext(5, false))
      })
    }
  }, [
    reviewPageClickedNext,
    dispatch,
    uiData,
    formIsValid,
    witnessFieldIsEmpty,
  ])
  return null
}
export default ReviewClaim
